export default "__VITE_ASSET__DfqDPA_K__"